import getAttachmentCollectionString from '../utils/getAttachmentCollectionString';
import getAttachmentWellInfoString from '../utils/getAttachmentWellInfoString';
import type AttachmentWellViewState from 'owa-attachment-well-data/lib/schema/AttachmentWellViewState';
import * as React from 'react';

const styles = require('./AttachmentWellPrintView.scss');

export interface AttachmentWellPrintViewProps {
    attachmentWellViewState: AttachmentWellViewState;
}

function AttachmentWellPrintView(props: AttachmentWellPrintViewProps) {
    const { attachmentWellViewState } = props;
    if (
        attachmentWellViewState.imageViewAttachments.length +
            attachmentWellViewState.docViewAttachments.length ===
        0
    ) {
        return null;
    } else {
        const attachIcon = require('../svg/attach.svg');

        return (
            <div className={styles.panel}>
                <div>
                    <img src={attachIcon} className={styles.attachIcon} />
                    <span className={styles.attachmentCountLabel}>
                        {getAttachmentWellInfoString(attachmentWellViewState, false, false)}
                    </span>
                </div>
                <div className={styles.attachmentCollectionContainer}>
                    <span className={styles.attachmentCollectionLabel}>
                        {getAttachmentCollectionString(attachmentWellViewState)}
                    </span>
                </div>
            </div>
        );
    }
}
export default AttachmentWellPrintView;
